import { render } from "./CatalogFilters.vue?vue&type=template&id=4c98df59"
import script from "./CatalogFilters.vue?vue&type=script&lang=js"
export * from "./CatalogFilters.vue?vue&type=script&lang=js"

import "./CatalogFilters.vue?vue&type=style&index=0&id=4c98df59&lang=scss"
script.render = render

export default script